import React, {Component} from 'react';
import PropTypes from 'prop-types';
import translate from '../../services/translation';


export default class PaginationControl extends Component {

	static propTypes = {
		loadMoreName: PropTypes.string,
		paginate: PropTypes.func.isRequired,
	};

	render() {

		return (
			<div className="paginationLoaderContainer">
				<div className="paginationControlContainer">
					<span onClick={this.props.paginate}>{this.props.loadMoreName || translate('pagination.load_more')}</span>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Filter/PaginationControl.js